// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8","7840":"f2d0f643"}[chunkId] || chunkId) + "." + {"501":"c64fb3781187c833","822":"653d1d2d44886255","1582":"24f6807fe77e210a","4316":"fa34d13f53bfedc2","7840":"b42a1370865f20e5","9133":"fc82a8b66721de00"}[chunkId] + ".js";
};